import { styled } from '../../../config/stitches'

const DraftEditorRootClass = '.DraftEditor-root'

const Wrapper = styled('div', {
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  overflow: 'hidden'
})

const BaseRoot = styled('div', {
  '.public-DraftEditorPlaceholder-inner': {
    lineHeight: '24px',
    fontSize: '$14'
  },
  '.public-DraftStyleDefault-block': {
    fontSize: '$14',
    lineHeight: '24px'
  },
  [DraftEditorRootClass]: {
    display: '-webkit-box',
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden'
  },
  variants: {
    lineClamp: {
      1: { [DraftEditorRootClass]: { '-webkit-line-clamp': 1 } },
      2: { [DraftEditorRootClass]: { '-webkit-line-clamp': 2 } },
      3: { [DraftEditorRootClass]: { '-webkit-line-clamp': 3 } }
    }
  }
})

const InputRoot = styled(BaseRoot, {
  maxWidth: '100%',
  width: '100%',
  padding: '12px 16px',
  backgroundColor: '$gray0200',
  borderRadius: '$8',
  variants: {
    dark: {
      true: {
        '&::placeholder': {
          color: '$whiteA500'
        },
        backgroundColor: '$whiteA050',
        border: 'none',
        '&:disabled': {
          color: '$whiteA300'
        },
        color: '$white',
        '.public-DraftEditorPlaceholder-inner': {
          color: '$whiteA500'
        }
      }
    },
    disabled: { true: {} }
  },
  compoundVariants: [
    {
      dark: true,
      disabled: true,
      css: {
        color: '$gray0600',
        cursor: 'default'
      }
    }
  ]
})

const ReadOnlyRoot = styled(BaseRoot, {
  maxWidth: '100%',
  width: '100%'
})

export const Root = {
  Wrapper,
  Input: InputRoot,
  ReadOnly: ReadOnlyRoot
}
